// extracted by mini-css-extract-plugin
module.exports = {"view-profile-btn":"StudentTable_view-profile-btn__N0IzG","view-group-col":"StudentTable_view-group-col__TMAJ7","table-heading":"StudentTable_table-heading__g16a5"};